import React from 'react';
import * as S from './styles'; // Ensure this path is correct
import Texts from '../Texts';
import { useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

interface PendingStatusProps {
  id: string;
  display_name: string;
}
const PendingStatus: React.FC<PendingStatusProps> = ({ id, display_name }) => {
  // const [loading, setLoading] = React.useState(true);
  //const status = 'personal';
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/identify`);
  };
  return (
    <S.ContentBox>
      <S.SuBox>
        <CircularProgress size={40} sx={{ color: '#FF833D' }} />
      </S.SuBox>
      <S.Title as="div">{Texts.Pending.title}</S.Title>
      <S.SubTitle as="div">{Texts.Pending.subTitle}</S.SubTitle>
      <S.DetailsBox>
        <LoadingButton
          size="small"
          onClick={handleClick}
          loading={true}
          variant="outlined"
          disabled
          sx={{
            width: '118px',
            height: '28px',
            fontSize: '10px',
            top: '10px',
            color: '#FC762B',
            '&.Mui-disabled': {
              color: 'red', // Customize text color when disabled
            },
          }}
          loadingPosition="end"
          endIcon={<span />} // Add an empty or actual icon here
        >
          {Texts.Pending.button}
        </LoadingButton>

        <S.Content>
          <div>{Texts.Pending.user}</div>
          <div style={{ fontSize: '12px' }}>
            {display_name}-{id}
          </div>
        </S.Content>
      </S.DetailsBox>
    </S.ContentBox>
  );
};

export default PendingStatus;
